"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageOut = void 0;
class MessageOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageOut.attributeTypeMap;
    }
}
exports.MessageOut = MessageOut;
MessageOut.discriminator = undefined;
MessageOut.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "eventId",
        "baseName": "eventId",
        "type": "string",
        "format": ""
    },
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "any",
        "format": ""
    },
    {
        "name": "tags",
        "baseName": "tags",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "timestamp",
        "baseName": "timestamp",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=MessageOut.js.map